/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.RecentlyViewed || (M.Template.RecentlyViewed = {});

M.Template.RecentlyViewed.Block = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<h3 class="filterHeading">Recently Viewed</h3>\n<div class="jcarousel-control recentlyViewedBlockControl"></div>\n<ul class="itemsContainer"></ul>\n';
}
return __p;
});

M.Template.RecentlyViewed.Item = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<div class="productPhotoBox">\n  <a href="'+
((__t=( M.html.htmlAttributeEscape(pdpUrl) ))==null?'':__t)+
'">\n    <img class="productPhoto shadowBorder"\n         src="'+
((__t=( M.html.htmlAttributeEscape(imgUrl) ))==null?'':__t)+
'" />\n  </a>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
